import { Button, DatePicker } from 'antd'
import styled from 'styled-components'

export const SearchDayWrapper = styled.div<{ margin_bottom?: string; width?: string }>`
  display: flex;
  border: 1px solid;
  border-radius: 5px;
  width: ${({ width }) => (width ? width : 'auto')};
  justify-content: space-between;
  margin-bottom: ${({ margin_bottom }) => (margin_bottom ? `${margin_bottom}px` : '10px')};
`
export const TitleSearch = styled.div<{ width?: string }>`
  width: 229px;
  padding: 0 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border-right: 1px solid;
`

export const SelectWrapper = styled.div`
  width: 318px;
`

export const TableCustom = styled.table`
  border: 1px solid;
  border-top: none;
`
export const HeaderCellWrapper = styled.th`
  border: 1px solid;
  border-top: none;
  min-width: 150px;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`
export const HeaderCellWrapperCustom = styled.th`
  border-left: 1px solid;
  border-bottom: 1px solid #e2eff9;
  display: block;
  width: max-content;
  padding: 0 10px;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`

export const HeaderCelDate = styled.th`
  border-top: 1px solid;
  border-top: none;
  text-align: center;
  background-color: #e2eff9;
  position: sticky;
  top: 0px;
`

export const DataCellWrapper = styled.td<{ position?: string; isError?: boolean }>`
  border: 1px solid;
  text-align: ${({ position }) => (position ? position : 'right')};
  padding: 5px;
  background-color: ${({ isError }) => isError && '#f291f1'};
  min-width: 50px;
`
export const DatePickerCustom = styled(DatePicker)`
  display: block;
  border: none !important;
`
export const Icon = styled.div`
  font-size: 19px;
  margin: 0 14px;
  display: flex;
  align-items: center;
`
export const RangeDateWrapper = styled.div`
  display: flex;
`
export const Line = styled.div`
  height: 1px;
  background-color: black;
  margin-bottom: 30px;
  width: 20%;
`

export const ButtonCustom = styled(Button)<{ marginLeft?: string }>`
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0')};
  width: 138px;
  margin-left: 30px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`
export const TableWrapper = styled.div`
  width: fit-content;
  text-align: right;
  width: auto;
`
export const EffortWrapper = styled.div`
  font-size: 10px;
  position: sticky;
  top: 10px;
`

export const ContainerTable = styled.div`
  margin-top: 20px;
`

export const WrapperFilter = styled.div`
  width: 80%;
`
export const CustomHeaderTable = styled.tr`
  position: sticky;
  top: 0px;
`

export const Wrappertable = styled.div`
  border-top: 1px solid;
  height: 600px;
  overflow: auto;
`
